// index.js (for React Web App)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Optional: Global CSS imports (can be customized for your project)
import App from './App'; // Importing the main App component
import 'process/browser';
import 'stream-browserify';

// Create a root element and render the entire app inside the 'root' div in index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
